module.exports = __webpack_public_path__ + "media/images/web/favicon/android-icon-48x48-f5efdd1e1594f469c8b16e9d98460cda.png";